import React, { useEffect, useState } from "react";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import Img from "react-webp-image";


const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        overflow: "hidden",
        padding: theme.spacing(0, 3)
    },
    avatar: {
        height: theme.spacing(4),
        width: theme.spacing(4)
    },
    paper: {
        maxWidth: 800,
        margin: `${theme.spacing(1)}px auto`,
        padding: theme.spacing(2)
    },
    optionPicture: {
        maxHeight: window.screen.height / 10,
        maxWidth: window.screen.width / 3,
    },
    pictureTile: {
        //minWidth: 800,
        maxHeight: window.screen.height / 7,
        maxWidth: window.screen.width / 1.5,
        // height: vh(15),
        margin: `${theme.spacing(1)}px auto`,
        padding: theme.spacing(2),
        //maxHeight: 100
    }
}));

export default function Option({ option, selectedA, selectedB, selectedC, selectedD, correctAnswer,
    isSubmited, isNextPressed, firstLifeLine, secondLifeLine, thirdLifeLine, optionImages, fiftyFiftyDisabled,
    aImage, bImage, cImage, dImage }) {
    const classes = useStyles();
    const [aColor, setAColor] = useState('white');
    const [bColor, setBColor] = useState('white');
    const [cColor, setCColor] = useState('white');
    const [dColor, setDColor] = useState('white');
    const [aTextColor, setATextColor] = useState('black');
    const [bTextColor, setBTextColor] = useState('black');
    const [cTextColor, setCTextColor] = useState('black');
    const [dTextColor, setDTextColor] = useState('black');
    const [aDisabled, setADisabled] = useState(false);
    const [bDisabled, setBDisabled] = useState(false);
    const [cDisabled, setCDisabled] = useState(false);
    const [dDisabled, setDDisabled] = useState(false);
    const [response, setResponse] = useState('')

    var aTextValue = ''
    var bTextValue = ''
    var cTextValue = ''
    var dTextValue = ''

    useEffect(() => {
        // setResponse("")
        // responses.push(response)
        if (isSubmited) {
            if (response === correctAnswer) {
                console.log("this is correct")
            }
            else {
                changeColors(response)
                console.log("Incorrect Answer")
            }
        }
        else {
            console.log("Not Submitted")
        }
    }, [isSubmited])

    useEffect(() => {
        if (fiftyFiftyDisabled) {
            setFiftyFiftyUI()
        }
    }, [thirdLifeLine])

    var randomItem;

    useEffect(() => {
        setFiftyFiftyUI()
        // if(thirdLifeLine === true){
        if (correctAnswer == 'a') {
            var array1 = ["b", "c", "d"];
            randomItem = array1[Math.floor(Math.random() * array1.length)];
            console.log('randomItem', randomItem)
        }
        else if (correctAnswer == 'b') {
            var array1 = ["a", "c", "d"];
            randomItem = array1[Math.floor(Math.random() * array1.length)];
            console.log('randomItem', randomItem)
        }
        else if (correctAnswer == 'c') {
            var array1 = ["a", "b", "d"];
            randomItem = array1[Math.floor(Math.random() * array1.length)];
            console.log('randomItem', randomItem)
        }
        else if (correctAnswer == 'd') {
            var array1 = ["a", "b", "c"];
            randomItem = array1[Math.floor(Math.random() * array1.length)];
            console.log('randomItem', randomItem)
        }
        if (randomItem == 'a') {
            if (correctAnswer == 'b') {
                cTextValue = ""
                dTextValue = ""
                setCDisabled(true)
                setDDisabled(true)
                setCColor("white");
                setCTextColor('white');
                setDColor("white");
                setDTextColor('white');
            }
            else if (correctAnswer == 'c') {
                bTextValue = ""
                dTextValue = ""
                setBDisabled(true)
                setDDisabled(true)
                setBColor("white");
                setBTextColor('white');
                setDColor("white");
                setDTextColor('white');
            }
            else if (correctAnswer == 'd') {
                bTextValue = ""
                cTextValue = ""
                setBDisabled(true)
                setCDisabled(true)
                setBColor("white");
                setBTextColor('white');
                setCColor("white");
                setCTextColor('white');
            }
        }
        else if (randomItem == 'b') {
            if (correctAnswer == 'a') {
                cTextValue = ""
                dTextValue = ""
                setCDisabled(true)
                setDDisabled(true)
                setCColor("white");
                setCTextColor('white');
                setDColor("white");
                setDTextColor('white');
            }
            else if (correctAnswer == 'c') {
                aTextValue = ""
                dTextValue = ""
                setADisabled(true)
                setDDisabled(true)
                setAColor("white");
                setATextColor('white');
                setDColor("white");
                setDTextColor('white');
            }
            else if (correctAnswer == 'd') {
                aTextValue = ""
                cTextValue = ""
                setADisabled(true)
                setCDisabled(true)
                setAColor("white");
                setATextColor('white');
                setCColor("white");
                setCTextColor('white');
            }
        }
        else if (randomItem == 'c') {
            if (correctAnswer == 'a') {
                bTextValue = ""
                dTextValue = ""
                setBDisabled(true)
                setDDisabled(true)
                setBColor("white");
                setBTextColor('white');
                setDColor("white");
                setDTextColor('white');
            }
            else if (correctAnswer == 'b') {
                aTextValue = ""
                dTextValue = ""
                setADisabled(true)
                setDDisabled(true)
                setAColor("white");
                setATextColor('white');
                setDColor("white");
                setDTextColor('white');
            }
            else if (correctAnswer == 'd') {
                aTextValue = ""
                bTextValue = ""
                setADisabled(true)
                setBDisabled(true)
                setAColor("white");
                setATextColor('white');
                setBColor("white");
                setBTextColor('white');
            }
        }
        else if (randomItem == 'd') {
            if (correctAnswer == 'a') {
                bTextValue = ""
                cTextValue = ""
                setBDisabled(true)
                setCDisabled(true)
                setBColor("white");
                setBTextColor('white');
                setCColor("white");
                setCTextColor('white');
            }
            else if (correctAnswer == 'b') {
                aTextValue = ""
                cTextValue = ""
                setADisabled(true)
                setCDisabled(true)
                setAColor("white");
                setATextColor('white');
                setCColor("white");
                setCTextColor('white');
            }
            else if (correctAnswer == 'c') {
                aTextValue = ""
                bTextValue = ""
                setADisabled(true)
                setBDisabled(true)
                setAColor("white");
                setATextColor('white');
                setBColor("white");
                setBTextColor('white');
            }

        }
        // }
    }, [thirdLifeLine])

    useEffect(() => {
        // arr.push(response)
        if (firstLifeLine) {
            if (correctAnswer == 'a') {
                changeA()
            }
            else if (correctAnswer == 'b') {
                changeB()
            }
            else if (correctAnswer == 'c') {
                changeC()
            }
            else if (correctAnswer == 'd') {
                changeD()
            }
        }
        // console.log('Final Responses',responses)
        // return () => {
        //     cleanup
        // }
    }, [firstLifeLine])

    useEffect(() => {
        if (isNextPressed) {
            setAColor("white");
            setATextColor('black');
            setBColor("white");
            setBTextColor('black');
            setCColor("white");
            setCTextColor('black');
            setDColor("white");
            setDTextColor('black');
            setADisabled(false)
            setBDisabled(false)
            setCDisabled(false)
            setDDisabled(false)
        }
        // return () => {
        //     cleanup
        // }
    }, [isNextPressed])
    // const options = option
    // options

    for (var key in option) {
        // console.log("Options",key,option[key])
        var value = option[key]
        if (key === "a") {
            aTextValue = value
        }
        else if (key === "b") {
            bTextValue = value
        }
        else if (key === "c") {
            cTextValue = value
        }
        else if (key === "d") {
            dTextValue = value
        }
        // setAText(aTextValue)
        // Do stuff. ex: console.log(dict[key])
    }
    function renderOptionImage(image, option) {
        if(option == 'a' && aDisabled){
            return (
                <span></span>
            )
        }
        else if(option == 'b' && bDisabled){
            return (
                <span></span>
            )
        }
        else if(option == 'c' && cDisabled){
            return (
                <span></span>
            )
        }
        else if(option == 'd' && dDisabled){
            return (
                <span></span>
            )
        }
        else if (image[0] != "") {
            return (
                <Grid item xs>
                    <Img webp={image[0]} alt="webp image" className={classes.optionPicture} />
                </Grid>
            )
        }
        else {
            return (
                <span></span>
            )
        }
    }

    // image url is in aImage, bImage, cImage, dImage
    var images = []
    images.push(optionImages)
    if (aImage != "" || bImage != "" || cImage != "" || dImage != "") {
        console.log("Option images if", aImage, bImage, cImage, dImage)

        let imageAPath = aImage.split("~")
        let imageBPath = bImage.split("~")
        let imageCPath = cImage.split("~")
        let imageDPath = dImage.split("~")
        console.log("imageAPath", imageAPath[0])

        return (
            <div className={classes.root}>

                <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                        <Paper className={classes.pictureTile} style={{ background: aColor }}
                            onClick={() => { changeA() }} >
                            <Grid container wrap="nowrap" spacing={2} >
                                <Grid item>
                                    <Avatar className={classes.avatar}>a</Avatar>
                                </Grid>
                                <Grid container wrap="nowrap" spacing={2} direction="column"
                                    justify="center"
                                    alignItems="center">
                                    {renderOptionImage(imageAPath, 'a')}
                                    <Grid item >
                                        <Typography variant="caption" style={{ color: aTextColor }}>{aTextValue}</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>


                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Paper className={classes.pictureTile} style={{ background: bColor }}
                            onClick={() => { changeB() }} >
                            <Grid container wrap="nowrap" spacing={2}>
                                <Grid item>
                                    <Avatar className={classes.avatar}>b</Avatar>
                                </Grid>
                                <Grid container wrap="nowrap" spacing={2} direction="column"
                                    justify="center"
                                    alignItems="center">
                                    {renderOptionImage(imageBPath, 'b')}

                                    <Grid item>
                                        <Typography variant="caption" style={{ color: bTextColor }}>{bTextValue}</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <Paper className={classes.pictureTile} style={{ background: cColor }}
                            onClick={() => { changeC() }} >
                            <Grid container wrap="nowrap" spacing={2}>
                                <Grid item>
                                    <Avatar className={classes.avatar}>c</Avatar>
                                </Grid>
                                <Grid container wrap="nowrap" spacing={2} direction="column"
                                    justify="center"
                                    alignItems="center">
                                    {renderOptionImage(imageCPath, 'c')}
                                    <Grid item>
                                        <Typography variant="caption" style={{ color: cTextColor }}>{cTextValue}</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>

                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Paper className={classes.pictureTile} style={{ background: dColor }}
                            onClick={() => { changeD() }} >
                            <Grid container wrap="nowrap" spacing={2}>
                                <Grid item>
                                    <Avatar className={classes.avatar}>d</Avatar>
                                </Grid>
                                <Grid container wrap="nowrap" spacing={2} direction="column"
                                    justify="center"
                                    alignItems="center">
                                    {renderOptionImage(imageDPath, 'd')}
                                    <Grid item>
                                        <Typography variant="caption" style={{ color: dTextColor }}>{dTextValue}</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>

                        </Paper>
                    </Grid>

                </Grid>




            </div>
        );
    }
    else {
        console.log("Option images else", images)
        return (

            <div className={classes.root}>
                {/* <ClickAwayListener touchEvent={false} mouseEvent={false}> */}
                <Paper className={classes.paper} style={{ background: aColor }}
                    onClick={() => { changeA() }} >
                    <Grid container wrap="nowrap" spacing={2}>
                        <Grid item>
                            <Avatar className={classes.avatar}>a</Avatar>
                        </Grid>
                        <Grid item xs>
                            <Typography variant="caption" style={{ color: aTextColor }}>{aTextValue}</Typography>
                        </Grid>
                    </Grid>
                </Paper>
                {/* </ClickAwayListener> */}
                <Paper className={classes.paper} style={{ background: bColor }}
                    onClick={() => { changeB() }} >
                    <Grid container wrap="nowrap" spacing={2}>
                        <Grid item>
                            <Avatar className={classes.avatar}>b</Avatar>
                        </Grid>
                        <Grid item xs>
                            <Typography variant="caption" style={{ color: bTextColor }}>{bTextValue}</Typography>
                        </Grid>
                    </Grid>
                </Paper>

                <Paper className={classes.paper} style={{ background: cColor }}
                    onClick={() => { changeC() }}>
                    <Grid container wrap="nowrap" spacing={2}>
                        <Grid item>
                            <Avatar className={classes.avatar}>c</Avatar>
                        </Grid>
                        <Grid item xs>
                            <Typography variant="caption" style={{ color: cTextColor }}>{cTextValue}</Typography>
                        </Grid>
                    </Grid>
                </Paper>

                <Paper className={classes.paper} style={{ background: dColor }}
                    onClick={() => { changeD() }}>
                    <Grid container wrap="nowrap" spacing={2}>
                        <Grid item>
                            <Avatar className={classes.avatar}>d</Avatar>
                        </Grid>
                        <Grid item xs>
                            <Typography variant="caption" style={{ color: dTextColor }}>{dTextValue}</Typography>
                        </Grid>
                    </Grid>
                </Paper>
            </div>
        );
    }


    function changeColors(response) {
        console.log('response', response, correctAnswer)
        if (response == 'a') {
            console.log("response is A")
            setAColor("red");
            setATextColor('white');
            if (correctAnswer == 'b') {
                console.log("answer is B")
                setBColor("green");
                setBTextColor('white');
            }
            else if (correctAnswer == 'c') {
                console.log("answer is C")
                setCColor("green");
                setCTextColor('white');
            }
            else if (correctAnswer == 'd') {
                console.log("answer is D")
                setDColor("green");
                setDTextColor('white');
            }
        }
        else if (response == 'b') {
            console.log("response is B")
            setBColor("red");
            setBTextColor('white');
            if (correctAnswer == 'a') {
                console.log("answer is A")
                setAColor("green");
                setATextColor('white');
            }
            else if (correctAnswer == 'c') {
                console.log("answer is C")
                setCColor("green");
                setCTextColor('white');
            }
            else if (correctAnswer == 'd') {
                console.log("answer is D")
                setDColor("green");
                setDTextColor('white');
            }
        }
        else if (response == 'c') {
            console.log("response is C")
            setCColor("red");
            setCTextColor('white');
            if (correctAnswer == 'a') {
                console.log("answer is A")
                setAColor("green");
                setATextColor('white');
            }
            else if (correctAnswer == 'b') {
                console.log("answer is B")
                setBColor("green");
                setBTextColor('white');
            }
            else if (correctAnswer == 'd') {
                console.log("answer is D")
                setCColor("green");
                setCTextColor('white');
            }
        }
        else if (response == 'd') {
            console.log("response is D")
            setDColor("red");
            setDTextColor('white');
            if (correctAnswer == 'a') {
                console.log("answer is A")
                setAColor("green");
                setATextColor('white');
            }
            else if (correctAnswer == 'b') {
                console.log("answer is B")
                setBColor("green");
                setBTextColor('white');
            }
            else if (correctAnswer == 'c') {
                console.log("answer is C")
                setCColor("green");
                setCTextColor('white');
            }
        }
    }

    function setFiftyFiftyUI() {
        if (!aDisabled) {
            if (bDisabled && cDisabled) {
                setAColor("green");
                setATextColor('white');
                setDColor("white");
                setDTextColor('black');
            }
            else if (bDisabled && dDisabled) {
                setAColor("green");
                setATextColor('white');
                setCColor("white");
                setCTextColor('black');
            }
            else if (cDisabled && dDisabled) {
                setAColor("green");
                setATextColor('white');
                setBColor("white");
                setBTextColor('black');
            }
        }
        if (!bDisabled) {
            if (aDisabled && cDisabled) {
                setAColor("green");
                setATextColor('white');
                setDColor("white");
                setDTextColor('black');
            }
            else if (bDisabled && dDisabled) {
                setAColor("green");
                setATextColor('white');
                setCColor("white");
                setCTextColor('black');
            }
            else if (cDisabled && dDisabled) {
                setAColor("green");
                setATextColor('white');
                setBColor("white");
                setBTextColor('black');
            }
        }
    }

    function changeA() {
        // setFiftyFiftyUI()
        if (!isSubmited) {
            if (!aDisabled && thirdLifeLine) {
                console.log("Status", thirdLifeLine, aDisabled, bDisabled, cDisabled, dDisabled)
                selectedA()
                setResponse('a')
                if (bDisabled && cDisabled) {
                    setAColor("green");
                    setATextColor('white');
                    setDColor("white");
                    setDTextColor('black');
                }
                else if (bDisabled && dDisabled) {
                    setAColor("green");
                    setATextColor('white');
                    setCColor("white");
                    setCTextColor('black');
                }
                else if (cDisabled && dDisabled) {
                    setAColor("green");
                    setATextColor('white');
                    setBColor("white");
                    setBTextColor('black');
                }
            }
            else {
                if (!aDisabled) {
                    setAColor("green");
                    setATextColor('white');
                    setBColor("white");
                    setBTextColor('black');
                    setCColor("white");
                    setCTextColor('black');
                    setDColor("white");
                    setDTextColor('black');
                    selectedA()
                    setResponse('a')
                }
            }
        }
    }

    function changeB() {
        if (!isSubmited) {
            if (!bDisabled && thirdLifeLine) {
                console.log("Status", thirdLifeLine, aDisabled, bDisabled, cDisabled, dDisabled)
                selectedB()
                setResponse('b')
                if (aDisabled && cDisabled) {
                    setBColor("green");
                    setBTextColor('white');
                    setDColor("white");
                    setDTextColor('black');
                }
                else if (aDisabled && dDisabled) {
                    setCColor("white");
                    setCTextColor('black');
                    setBColor("green");
                    setBTextColor('white');
                }
                else if (cDisabled && dDisabled) {
                    setAColor("white");
                    setATextColor('black');
                    setBColor("green");
                    setBTextColor('white');
                }
            }
            else {
                if (!bDisabled) {
                    setAColor("white");
                    setATextColor('black');
                    setBColor("green");
                    setBTextColor('white');
                    setCColor("white");
                    setCTextColor('black');
                    setDColor("white");
                    setDTextColor('black');
                    selectedB()
                    setResponse('b')
                }
            }
        }
    }

    function changeC() {
        if (!isSubmited) {
            if (!cDisabled && thirdLifeLine) {
                console.log("Status", thirdLifeLine, aDisabled, bDisabled, cDisabled, dDisabled)
                selectedC()
                setResponse('c')
                if (aDisabled && bDisabled) {
                    setCColor("green");
                    setCTextColor('white');
                    setDColor("white");
                    setDTextColor('black');
                }
                else if (aDisabled && dDisabled) {
                    setCColor("green");
                    setCTextColor('white');
                    setBColor("white");
                    setBTextColor('black');
                }
                else if (bDisabled && dDisabled) {
                    setCColor("green");
                    setCTextColor('white');
                    setAColor("white");
                    setATextColor('black');
                }
            }
            else {
                if (!cDisabled) {
                    setAColor("white");
                    setATextColor('black');
                    setBColor("white");
                    setBTextColor('black');
                    setCColor("green");
                    setCTextColor('white');
                    setDColor("white");
                    setDTextColor('black');
                    selectedC()
                    setResponse('c')
                }
            }
        }
    }

    function changeD() {
        if (!isSubmited) {
            if (!dDisabled && thirdLifeLine) {
                console.log("Status", thirdLifeLine, aDisabled, bDisabled, cDisabled, dDisabled)
                selectedD()
                setResponse('d')
                if (aDisabled && bDisabled) {
                    setDColor("green");
                    setDTextColor('white');
                    setCColor("white");
                    setCTextColor('black');
                }
                else if (aDisabled && cDisabled) {
                    setDColor("green");
                    setDTextColor('white');
                    setBColor("white");
                    setBTextColor('black');
                }
                else if (bDisabled && cDisabled) {
                    setDColor("green");
                    setDTextColor('white');
                    setAColor("white");
                    setATextColor('black');
                }
            }
            else {
                if (!dDisabled) {
                    setAColor("white");
                    setATextColor('black');
                    setBColor("white");
                    setBTextColor('black');
                    setCColor("white");
                    setCTextColor('black');
                    setDColor("green");
                    setDTextColor('white');
                    selectedD()
                    setResponse('d')
                }
            }
        }
    }
}
